<template>
  <div class="course-detail-edite-wrap">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);padding:30px 20px;">
        <!-- <div class="course-detail-img">
          <img :src="couseCoverUrl" alt="">
        </div>   -->
        <div class="course-detail-info">
          <div class="course-detail-name">{{gradeName}}</div>
          <!-- <div class="course-detail-price">所属课程：艺术综合</div> -->
          <div class="course-detail-desc">
            <span >所属课程：{{gradeCourseNames}}</span>
            <span >班级容量：{{gradeCapacity}}人</span>
            <span >班级老师：{{teachers}}</span>
          </div>
          <div class="course-detail-desc">
            <span >备注：{{gradeRemark}}</span>
          </div>
        </div>
        <!-- <div class="course-detail-right">
          <a-button @click="editeCourse()" type="primary" style="margin-left:8px;">编辑</a-button>
        </div> -->
      </a-card>
      <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <a-tabs defaultActiveKey="1" >
          <a-tab-pane tab="排课信息" key="1">
            <ClassCourseList :courseId = "courseId"></ClassCourseList>
          </a-tab-pane>
          <a-tab-pane tab="班级学员" key="2" forceRender>
            <ClassStudentsList></ClassStudentsList>
          </a-tab-pane>

        </a-tabs>
      </a-card>
      <!-- <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        
      </a-card> -->

  </div>
  
</template>

<script>

  import ClassCourseList from './classDetail/ClassCourseList' 
  import ClassStudentsList from './classDetail/ClassStudentsList' 
  
  import {getGradeDetail} from '@/api/api'
  export default {
    name: 'ClassDetail',
    components: {ClassCourseList,ClassStudentsList},
    mixins: [],
    data() {
      return {
        id:"",
        teachers:"",
        gradeName:"",//课程名称
        gradeCapacity:"",
        gradeRemark:"",
        courseId:"",//课程加个
        gradeCourseNames:"",
      }
    },
    created() {
      this.id = this.$route.query.id;
      this.getCourseDetailInfo();
    },
    methods: {
      getCourseDetailInfo(){
        getGradeDetail({id:this.id}).then((res)=>{
          if(res.code==0){
            this.gradeName = res.result.gradeName;
            this.courseId = res.result.courseId;
            this.gradeCapacity = res.result.gradeCapacity;
            this.gradeRemark = res.result.gradeRemark;
            this.gradeCourseNames = res.result.gradeCourseNames;
            
            let teacherArr = [];
            let teacherList = res.result.gradeTeacherList || [];
            teacherList.map((item,i)=>{
              teacherArr.push(item.realname);
            })

            this.teachers = teacherArr.join(',');

          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      }

      
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .course-detail-edite-wrap{

    .course-detail-img{
      float:left;
      width:132px;
      height:86px;
      img{
        width:100%;
      }
    }
    .course-detail-info{
      float:left;
      margin-left:14px;
      .course-detail-name{
        color:#333333;
        margin-bottom:5px;
      }
      .course-detail-price{
        color:#FA6400;
        font-size:14px;
      }
      .course-detail-desc{
        color:#999999;
        font-size:12px;
        margin-top:10px;
        span{
          margin-right:10px;
        }
      }
    }
    .course-detail-right{
      float:right;
    }

    

    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    } 

  }
  

</style>